{
  "nav": {
    "pricing": "Pricing",
    "contact": "Contact",
    "menu": "Menu",
    "login": "Log in",
    "features": "Features",
    "brandHomeAria": "Done-it — home",
    "market": {
      "belgium": "Belgium",
      "international": "Worldwide"
    }
  },
  "footer": {
    "tagline": "Done-it — Time tracking made simple.",
    "terms": "Terms",
    "privacy": "Privacy",
    "contact": "Contact"
  },
  "help": "Need help?",
  "continue": "Continue",
  "back": "Back",
  "change": "Change",
  "retry": "Retry",
  "errors": {
    "unexpected": "Unexpected error"
  },
  "step": {
    "of": "Step {{n}} of {{total}}"
  },
  "funnel": {
    "title": "Subscription · Done-it"
  }
}
